<template>
  <div class="anu-converter">
    <div class="col-sm-6 offset-3">
      <p><strong>Enter card in the box and the converted CSN will appear for you:</strong></p>
      <input type="text" class="form-control" v-model="csn">
      <br>
      <p><strong>Converted:</strong></p>
      <pre>{{ csnConverted }}</pre>
      <router-link :to="{ path: '/membership/smartcards' }" exact class="btn btn-primary mb-2">
        Return to Smartcards
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ANUConverter',
  computed: {
    csnConverted () {
      let converted = this.csn
      if (converted.length > 0) {
        converted = converted.match(/.{1,2}/g)
        converted = converted.reverse()
        converted = converted.join('')
        return converted
      } else {
        return 'No CSN entered'
      }
    }
  },
  data () {
    return {
      csn: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ANUConverter.vue